import GidcPlugin from '@gidc/plugin'
import FastClick from 'fastclick'
import { Toast, Dialog, ActionSheet } from '@gidc/mobile'
import Utils from '@/common/utils'
import Apis from '@/apis'
import { Request } from '@/common/request'
import Mock from '../../mock/index'
import { commafy, delcommafy } from '../apis/apiFunction'

import '@gidc/mobile/components/_style/global.styl'

const install = (
  Vue,
  options = {
    request: true,
    validate: true
  }
) => {
  if (!Vue || install.installed) {
    return
  }

  const properties = {
    $remote: {
      value: new Request()
    },
    $commafy: {
      value: commafy
    },
    $delcommafy: {
      value: delcommafy
    },
    $toast: {
      value: Toast
    },
    $dialog: {
      value: Dialog
    },
    $actionsheet: {
      value: ActionSheet
    },
    $utils: {
      value: Utils
    },
    $apis: {
      value: Apis
    }
  }

  // 设置rem
  Utils.setRootFontSize(document)

  // 引入FastClick
  if ('addEventListener' in document && 'ontouchstart' in window) {
    FastClick.prototype.focus = function (targetElement) {
      targetElement.focus()
    }
    document.addEventListener('DOMContentLoaded', function () {
      FastClick.attach(document.body)
    }, false)
  }

  // 使用gidc-plugin
  if (Object.prototype.hasOwnProperty.call(options, 'validate') && !!options.validate) {
    Vue.use(GidcPlugin)
  }

  // 启用mock
  if (process.env.VUE_APP_OPEN_MOCK === 'true') {
    Mock()
  }

  // 注入依赖至原型链
  Object.defineProperties(Vue.prototype, properties)
}

export default install
